export const initCds2Chooser = () => {
	const chooser = document.querySelector( 'section.cds2-chooser' );

	if ( !chooser )
	{
		return;
	}

	if ( chooser.classList.contains( 'commercial' ) )
	{
		const commercialNavigation = document.querySelector( 'html > body > nav' );

		if ( commercialNavigation )
		{
			commercialNavigation.classList.add( 'commercial' );
		}
	}

	const sort = chooser.querySelector( 'div.sort' );

	if ( !sort )
	{
		return;
	}

	document.addEventListener( 'click', ( evt ) => {
		if (
			( !evt.target.closest( 'div.sort' ) && !sort.classList.contains( 'show' ) )
			|| ( evt.target.closest( 'div.sort ul' ) && sort.classList.contains( 'show' ) )
		)
		{
			if ( sort.classList.contains( 'show' ) )
			{
				const requestedLabel = evt.target.closest( 'label' );
				if ( requestedLabel )
				{
					const requestedInput = requestedLabel.previousElementSibling;
					
					Array.from( sort.querySelectorAll( 'input:checked' ) ).forEach( ( it ) => {
						it.checked = false;
					} );

					if ( requestedInput.name !== 'sort[field]' )
					{
						requestedLabel.closest( 'li' ).previousElementSibling.children[0].checked = true;
					}
					
					sort.querySelector( 'button span.value' ).innerHTML = requestedLabel.innerHTML;
					sort.classList.remove( 'show' );
				}
			}
			
			return;
		}

		sort.classList.toggle( 'show' );
	} );

	const propertiesList = chooser.querySelector( 'li.properties div.unfolding-checkbox-list ul' );

	if ( propertiesList )
	{
		document.querySelector( 'input#unfolding-list-properties' ).checked = false;
		
		const handleProperties = () => {
			propertiesList.classList.remove( 'ready' );
			
			const propertiesItems = Array.from( propertiesList.querySelectorAll( 'li:not( :last-child )' ) );
			const lastLabel = propertiesList.querySelector( 'li:last-child' );
			let availableWidth = propertiesList.offsetWidth - lastLabel.offsetWidth - 8;
			let visibleItemsWidth = 0;
			let startHiding = false;
			let firstLine = true;

			propertiesItems.forEach( ( it ) => {
				it.classList.remove( 'hidden' );
				
				if ( startHiding )
				{
					it.classList.add( 'hidden' );

					return;
				}
				
				visibleItemsWidth += it.offsetWidth + 8;

				if ( firstLine && visibleItemsWidth > availableWidth )
				{
					firstLine = false;
					availableWidth = propertiesList.offsetWidth - lastLabel.offsetWidth - it.offsetWidth - 16;
					visibleItemsWidth = 0;
				}
				else if ( !firstLine && visibleItemsWidth > availableWidth )
				{
					visibleItemsWidth -= it.offsetWidth + 8;
					it.classList.add( 'hidden' );
					startHiding = true;
				}
			} );

			propertiesList.classList.add( 'ready' );
		};

		handleProperties();
		window.addEventListener( 'resize', handleProperties );
	}
};
